module.exports = __webpack_public_path__ + "img/WelcomeImageSide.abbfa302.png";